module.exports = __webpack_public_path__ + "static/media/nps-detractor.e86a7626.svg";